export const CREATE_CATEGORY_ACTION = '[Category Action] Create Category';
export const CONFIRMED_CREATE_CATEGORY_ACTION = '[Category Action] Confirmed Create Category';
export const GET_CATEGORY = '[Category Action] Get Category';
export const CONFIRMED_GET_CATEGORIES = '[Category Action] Confirmed Get Categories';
export const EDIT_CATEGORY_ACTION = '[Category Action] Edit Category';
export const CONFIRMED_EDIT_CATEGORY_ACTION = '[Category Action] Confirmed Edit Category';
export const CONFIRMED_DELETE_CATEGORY_ACTION = '[Category Action] Confirmed Delete Category';
export const CREATE_CATEGORY_ERROR_ACTION = '[Category Action] Error';
export const CLEAR_CATEGORY_ERROR = '[Category Action] Clear Error';
export const LOADING_TOGGLE_ACTION = '[Category Action] Loading for Category';


